<template>
  <div class="text-sm font-medium text-gray-500">{{this.$t('statistics.messagesByAgent')}}</div>
  <apexchart height="380" type="donut" :options="messagesByAgentOptions" :series="messagesByAgentSeries"></apexchart>
</template>

<script>
import { useAgentStore } from '@/stores/agents'
import { useMessagesByAgentsStore } from '@/stores/messagesByAgent'
import messagesByAgentModel from '@/models/messages-by-agent'

export default {
  name: 'MessagesByAgent',
  async created() {
    await this.fetchMessagesByAgent();
  },
  setup() {
    let agentStore = useAgentStore();
    let statisticsStore = useMessagesByAgentsStore();
    return { agentStore, statisticsStore };
  },
  computed: {
        messagesByAgentOptions() {
      let labels = [];
      if (this.statisticsStore.collection) {
        this.statisticsStore.collection.forEach(row => {
          if (row['agent']) {
            labels.push(row['agent'].attributes.name);
          }
        });
      }
      return {
        labels: labels,
        colors: ['#6366f1', '#4c1d95', '#3b82f6', '#581c87', '#0ea5e9', '#701a75', '#06b6d4',
                 '#312e81', '#8b5cf6', '#1e3a8a', '#a855f7', '#0c4a6e', '#d946ef', '#164e63'],
        chart: {
          id: 'messages-by-agent',
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: false,
              },
            },
          },
        },
        responsive: [{
          options: {
            legend: {
              show: false,
            },
          },
        }],
      };
    },
    messagesByAgentSeries() {
      let dataset = [];
      if (this.statisticsStore.collection) {
        this.statisticsStore.collection.forEach(row => {
          dataset.push(row['count']);
        });
      }
      return dataset;
    },
  },
  methods: {
    async fetchMessagesByAgent() {
      let dataset = await messagesByAgentModel.getMessagesByAgentStatistics(this.axios, this.$root.token);
      let resultSet = [];
      dataset.data.data.forEach(row => {
        let count = row.attributes['count'];
        let agent = this.agentStore.getById(row.id);
        if (agent) {
          resultSet.push({'agent': agent, 'count': count, id: row.id});
        }
      });
      resultSet.sort((a, b) => b.count > a.count);
      resultSet.forEach(r => {
        this.statisticsStore.replaceOrAdd(r);
      });
    },
  },
}
</script>
